export const statusMember = status => {
    switch ( String(status) ) {
        case 'APPROVED':
            return { title: `อนุมัติ` , color: `success`}
        case 'REJECT':
            return { title: `ไม่อนุมัติ` , color: `danger`} 
        default:
            return { title: `ไม่พบสถานะ` , color: `dark`}
    }
};